module.exports = __webpack_public_path__ + "static/img/pushpin-green.b89ea96a.png";